/**
 * IMPORTS
 */

import { IStatusRemessaPayload } from "@/hooks/remessas/status-remessa-do-cliente/index.d";

import { statusRemessaRepository } from "@/repositories/status-remessa";

/**
 * Função que solicita remessas 🛠️.
 */
const handleStatusRemessa = async (
  accessToken: string,
  cliente_id: number,
  payload: IStatusRemessaPayload
) => {
  try {
    const data = await statusRemessaRepository.handleStatusRemessa(
      accessToken,
      cliente_id,
      payload
    );

    return data;
  } catch (error: any) {
    console.log("ERROR EM ATUALIZAR O STATUS DA REMESSA: ", error);

    return error;
  }
};

/**
 * EXPORTS
 */
export { handleStatusRemessa };
